// extracted by mini-css-extract-plugin
module.exports = {"info":"toasts_info__2qBbD","modal":"toasts_modal__2SvQG"};